import React from 'react';
import { Loader2, Menu } from 'lucide-react';
import { Button } from '../ui/button';
import LayoutFooter from '../layout/LayoutFooter';
import BrandLogo from '../layout/BrandLogo';
import { useResponsive } from '../../context/ResponsiveContext';
import { getFooterMeta } from '../../utils/footerMeta';

const MOBILE_HEADER_ICON =
  'h-9 w-9 min-h-9 min-w-9 md:h-8 md:w-8 md:min-h-8 md:min-w-8';

/**
 * Branded shell shown while auth bootstraps on protected routes.
 * Keeps header/footer landmarks so mobile layout QA does not false-fail during load.
 */
export default function AuthBootstrapShell() {
  const { isMobile } = useResponsive();
  const { year, monthYear } = getFooterMeta();

  return (
    <div className="layout-shell overflow-hidden bg-gray-50 dark:bg-gray-900 flex flex-col">
      <header className="bg-white dark:bg-gray-900 shadow-sm border-b border-gray-200 dark:border-gray-700 fixed top-[var(--browser-recommendation-banner-h,0px)] left-0 right-0 z-[100] flex-shrink-0 header-safe safe-area-left safe-area-right">
        <div className="flex h-[var(--header-h)] w-full min-w-0 items-center gap-1.5 px-2 md:gap-2 md:px-3">
          {isMobile ? (
            <Button
              variant="ghost"
              size="icon"
              className={MOBILE_HEADER_ICON}
              aria-label="Open navigation"
              disabled
            >
              <Menu className="h-5 w-5" />
            </Button>
          ) : null}
          <div className="flex min-w-0 max-w-[min(10rem,calc(100vw-12rem))] md:max-w-[min(12rem,calc(100vw-24rem))] items-center">
            <BrandLogo variant="full" className="min-w-0" />
          </div>
        </div>
      </header>

      <main
        id="main-content"
        tabIndex={-1}
        className="flex flex-1 items-center justify-center pt-[var(--layout-header-offset)]"
      >
        <Loader2 className="h-12 w-12 animate-spin text-blue-600" aria-label="Loading" />
      </main>

      <LayoutFooter year={year} monthYear={monthYear} />
    </div>
  );
}
